import storage from "@/plugins/storage";

const base = globalThis.Smart?.env?.BASE_URL ?? "";

/**
 * Login acontece nas páginas do BFF (mesma origem): navegação full-page
 * carregando o destino do hash-router em `redirect`.
 */
export function goToLogin(redirect = "/") {
  const query = new URLSearchParams({ redirect });
  globalThis.location.assign(`${base}/auth/login?${query}`);
}

/**
 * Tela de confirmação de email no BFF, reenviando um novo código.
 * Usada onde o app pede para o usuário confirmar o email.
 */
export function goToConfirmEmail(redirect = "/") {
  const query = new URLSearchParams({ send: "1", redirect });
  globalThis.location.assign(`${base}/auth/confirm-email?${query}`);
}

/**
 * Migração one-shot pós-cutover: troca o refresh_token que vivia no
 * localStorage por uma sessão de cookie no BFF, evitando deslogar todo
 * mundo no deploy. Remover junto com o endpoint /auth/legacy (~90 dias).
 */
export async function migrateLegacySession() {
  const refreshToken = storage.getItem("api:refresh_token");
  if (!refreshToken) {
    return;
  }

  const clear = () => {
    storage.removeItem("api:access_token");
    storage.removeItem("api:refresh_token");
  };

  if (globalThis.Smart?.auth?.authenticated) {
    clear();
    return;
  }

  try {
    const response = await fetch(`${base}/auth/legacy`, {
      method: "POST",
      headers: { "content-type": "application/json" },
      body: JSON.stringify({ refresh_token: refreshToken }),
    });
    clear();
    if (response.ok) {
      globalThis.location.reload();
    }
  } catch {
    // Falha de rede: mantém os tokens e tenta no próximo boot
  }
}
